import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { LiveSession } from "../live-courses/types";
import type { CourseJournal, MyJournal, SaveJournalData } from "./types";

export * from "./types";

/**
 * Jonli kursning sinf jurnali — davomat va kundalik baholar bitta jadvalda.
 *
 * `get()` jurnal ekraniga kerak bo'lgan hamma narsani bitta so'rovda qaytaradi
 * (ustunlar — sessiyalar, qatorlar — o'quvchilar, har juftlikka bitta katak,
 * ustiga yakunlar), har bir yozish esa yangilangan jadvalni qaytaradi —
 * shuning uchun ekranga ikkita javobni bir-biriga ulash hech qachon to'g'ri
 * kelmaydi.
 */
export class JournalApi extends BaseApi {
  private readonly baseUrl: string = "/journal";

  /** Kursning butun jadvali (o'qituvchi/xodim). */
  get(courseId: number) {
    return this.request.get<CourseJournal, ApiResponse<CourseJournal>>(
      `${this.baseUrl}/courses/${courseId}`,
    );
  }

  /** Bitta darsning davomati va kundalik baholarini saqlaydi. */
  saveSession(sessionId: number, data: SaveJournalData) {
    return this.request.put<CourseJournal, ApiResponse<CourseJournal>>(
      `${this.baseUrl}/sessions/${sessionId}`,
      data,
    );
  }

  /** Darsning kundalik bahosi nechadan qo'yilishini belgilaydi. */
  setMaxScore(sessionId: number, maxScore: number) {
    return this.request.patch<LiveSession, ApiResponse<LiveSession>>(
      `${this.baseUrl}/sessions/${sessionId}/max-score`,
      { maxScore },
    );
  }

  /** Kundalik baholarni darsning uy vazifasi natijalaridan to'ldiradi. */
  syncHomework(sessionId: number) {
    return this.request.post<CourseJournal, ApiResponse<CourseJournal>>(
      `${this.baseUrl}/sessions/${sessionId}/sync-homework`,
    );
  }

  /** Joriy o'quvchining o'z qatori. */
  getMine(courseId: number) {
    return this.request.get<MyJournal, ApiResponse<MyJournal>>(
      `${this.baseUrl}/courses/${courseId}/me`,
    );
  }
}

export const journalApi = new JournalApi();
